module.exports = __webpack_public_path__ + "img/16_100.6c3f595b.png";